import { useDispatch, useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';
// defaultTheme
import themes from 'themes';
import { themeNeumorphic } from 'themes/themeNeumorphic';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { useEffect } from 'react';
import { Add_Cart, Add_CartCustomer, Add_Images, Add_ImagesCustomer } from 'store/actions';
// ==============================|| APP ||============================== //

const App = () => {
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);
    useEffect(() => {
        dispatch({ type: Add_Cart, cart: JSON.parse(localStorage.getItem('cart')) ? JSON.parse(localStorage.getItem('cart')).cart : [] });
        dispatch({
            type: Add_Images,
            images: JSON.parse(localStorage.getItem('images')) ? JSON.parse(localStorage.getItem('images')).images : []
        });
        dispatch({
            type: Add_ImagesCustomer,
            images: JSON.parse(localStorage.getItem('imagesCustomer')) ? JSON.parse(localStorage.getItem('imagesCustomer')).images : []
        });
        dispatch({
            type: Add_CartCustomer,
            cart: JSON.parse(localStorage.getItem('cartCustomer')) ? JSON.parse(localStorage.getItem('cartCustomer')).cart : []
        });
    }, []);
    const activeTheme = customization.themeMode === 'neumorphic' ? themeNeumorphic(customization) : themes(customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={activeTheme}>
                <CssBaseline />
                <NavigationScroll>
                    <Routes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
